import { useContext, useState } from 'react';
import { ExternalLink } from 'lucide-react';
import { MyContext } from '../context';
import SimpleDropdown from './SimpleDropdown';
import CreateStoreWizard from './CreateStoreWizard';
import LaunchStoreModal from './LaunchStoreModal';
import { useCan } from '../hooks/useCan';
import { PLATFORMADMIN_ROLES } from './navConfig';
import { launchStore } from '../utils/launchStore';

const NEW_STORE_VALUE = '__new_store__';

const StoreSwitcher = () => {
	const { stores, activeStoreId, setActiveStoreId } = useContext(MyContext);
	const canCreateStore = useCan(PLATFORMADMIN_ROLES);
	const [wizardOpen, setWizardOpen] = useState(false);
	const [launchOpen, setLaunchOpen] = useState(false);
	const activeStore = stores.find((s) => s.storeId === activeStoreId);

	const options = [
		...(canCreateStore ? [{ value: NEW_STORE_VALUE, label: '+ New Store' }] : []),
		...stores.map((s) => ({ value: s.storeId, label: s.storeName })),
	];

	const handleChange = (value) => {
		if (value === NEW_STORE_VALUE) {
			setWizardOpen(true);
			return;
		}
		setActiveStoreId(value);
	};

	return (
		<div className='flex items-center gap-2 mr-6'>
			<span className='text-sm'>Store: </span>
			<SimpleDropdown value={activeStoreId} onChange={handleChange} options={options} className='w-72' />
			<button
				type='button'
				className='p-2 rounded-md border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'
				onClick={() => launchStore(activeStore, () => setLaunchOpen(true))}
				disabled={!activeStore}
				aria-label='Launch store'
				title={activeStore?.storefrontType === 'iframe' ? 'Open store in an iframe test page' : 'Launch store in a new tab'}
			>
				<ExternalLink className='size-4 text-gray-600' />
			</button>
			<CreateStoreWizard open={wizardOpen} setOpen={setWizardOpen} />
			{activeStore && (
				<LaunchStoreModal
					open={launchOpen}
					setOpen={setLaunchOpen}
					storeId={activeStore.storeId}
					storeName={activeStore.storeName}
					allowGuestCheckout={activeStore.allowGuestCheckout}
				/>
			)}
		</div>
	);
};

export default StoreSwitcher;
